import { getAnalytics } from "firebase/analytics";
import { initializeApp } from "firebase/app";

const firebaseConfig = {
    apiKey: "AIzaSyAEsZApKBgn5wEl5tilcsyZQ1NXDw1mpu0",
    authDomain: "calculadora-sueldo-a5859.firebaseapp.com",
    projectId: "calculadora-sueldo-a5859",
    storageBucket: "calculadora-sueldo-a5859.appspot.com",
    messagingSenderId: "1071637158519",
    appId: "1:1071637158519:web:29cd6cc385b03eead38472",
    measurementId: "G-DVNJDJ26DG"
  };
  
  // Initialize Firebase
  export const initializeAnalytics = () => {
    const app = initializeApp(firebaseConfig);
    return getAnalytics(app)
  }